module.exports = __webpack_public_path__ + "static/media/plan-C1b-mobile-en.744872a9.png";